<script setup>
const props = defineProps({
  icon: String,
  label: String,
  href: String,
})
</script>

<template>
  <a :href="href"
     class="block p-4 text-center rounded-lg hover:bg-gray-100 group">
    <span
      class="fa text-xl mx-auto mb-2 w-5 h-5 text-cyan-500 group-hover:text-cyan-600"
      :class="`fa-${icon}`">
    </span>
    <div class="text-sm font-medium text-cyan-500" v-text="label"></div>
  </a>
</template>
